import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button } from "./ui/button";
import presidentialImg from "@/assets/presidential-suite.webp";
import executiveImg from "@/assets/executive-suite.webp";
import safariBedImg from "@/assets/safari-bedroom.webp";
import cheetahRoomImg from "@/assets/cheetah-room.webp";

const rooms = [
  { image: presidentialImg, title: "Presidential Suite", desc: "Epitome of regal opulence" },
  { image: executiveImg, title: "Executive Suites", desc: "Premium amenities with private swimming pool" },
  { image: safariBedImg, title: "Safari Suites", desc: "True African experience" },
  { image: cheetahRoomImg, title: "Main Lodge Rooms", desc: "Standard en-suite rooms, private balconies" },
];

const RoomsSection = () => {
  return (
    <section id="rooms" className="bg-lodge-deep py-4 sm:py-6 lg:py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <p className="eyebrow text-center">
          Accommodation
        </p>
        <h2 className="font-heading text-2xl md:text-4xl tracking-wider text-foreground text-center mb-3">
          WHERE YOU&rsquo;LL STAY
        </h2>
        <p className="text-sm text-muted-foreground text-center mb-12 whitespace-pre-line">
          Loved for Privacy, Food, and Personal Service.{"\n"}
          Guests consistently highlight:{"\n"}
          Exceptional dining experiences{"\n"}
          Warm, attentive hospitality{"\n"}
          Peaceful, romantic atmosphere{"\n"}
          Memorable special occasions
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-10">
          {rooms.map((room) => (
            <Link
              key={room.title}
              to="/rooms"
              aria-label={`${room.title} — luxury safari suites at Zwahili in Limpopo`}
              className="group relative overflow-hidden rounded"
            >
              <div className="aspect-[3/2] overflow-hidden">
                <img
                  src={room.image}
                  alt={`${room.title} — luxury safari suite at Zwahili Private Game Lodge in Limpopo`}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                  loading="lazy"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-lodge-dark/90 via-transparent to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <h3 className="font-heading text-lg mb-1 text-primary-foreground">{room.title}</h3>
                <p className="text-xs text-primary-foreground">{room.desc}</p>
              </div>
            </Link>
          ))}
        </div>

        <div className="flex justify-center">
          <Link to="/rooms" aria-label="Browse all luxury safari suites at Zwahili Private Game Lodge">
            <Button variant="hero" size="lg" className="text-xs tracking-widest uppercase">
              BROWSE ACCOMMODATION&nbsp;<ArrowRight size={16} />
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default RoomsSection;
